import { render, staticRenderFns } from "./LConfirmDialog.vue?vue&type=template&id=27d2e446&scoped=true"
import script from "./LConfirmDialog.vue?vue&type=script&lang=ts"
export * from "./LConfirmDialog.vue?vue&type=script&lang=ts"
import style0 from "./LConfirmDialog.vue?vue&type=style&index=0&id=27d2e446&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d2e446",
  null
  
)

export default component.exports